/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

import { Col, Collapse } from "reactstrap";

import "./VerticalTimeline.scss";

import "react-perfect-scrollbar/dist/css/styles.css";

//i18n
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";

// Moment
import * as moment from "moment";
import "moment-duration-format";

const VerticalTimeline = (props) => {
  const [collapse, setCollapse] = useState([]);
  const { t } = useTranslation();

  return (
    <>
      <Col>
        <div className="tab-acordeon-timeline w-100">
          <div
            className="d-flex extra-info-sub-item pointer mb-0 py-0 pl-0"
            style={{ marginTop: "20px" }}
            onClick={() => {
              let aux = [...collapse];
              aux[0] = !aux[0];
              setCollapse(aux);
            }}
          >
            <div className="font-weight-bold p-0">
              {t("Journey details")}
              <span className="icon-ticket-timeline" align="left">
                <i
                  className={`bx bx bxs-chevron-right color font-size-15 item ${
                    collapse[0] ? "opened" : "closed"
                  }`}
                />
              </span>
            </div>
          </div>
        </div>

        <Collapse className="mx-0 my-0 " isOpen={collapse[0]}>
          <div>
            <ul className="StepProgress">
              <li className="StepProgress-item is-done">
                <span className="primary-text-progress"> {t("Start")}</span>
                <span className="second-text-progress">
                {props?.start ? moment(props?.start).format('DD/MM/YYYY HH:mm:ss') : " "}

                </span>
              </li>
              {props?.processsData?.map((process) =>
                process.date != null ? (
                  <li className="StepProgress-item is-done">
                    <span className="primary-text-progress">
                      {process.tabName}
                    </span>
                    <span className="second-text-progress">
                      {process?.date ? moment(process?.date).format('DD/MM/YYYY HH:mm:ss') : " "}
                  </span>
                  </li>
                ) : (
                  <li className="StepProgress-item">
                    <span className="primary-text-progress">
                      {process.tabName}
                    </span>
                    <span className="second-text-progress">
                    {process?.date ? moment(process?.date).format('DD/MM/YYYY HH:mm:ss') : " "}
                    </span>
                  </li>
                )
              ).reverse()}

              {props?.finished != null ? (
                <li className="StepProgress-item is-last-item-complete">
                  <span className="primary-text-progress">Finalizada</span>
                  <span className="second-text-progress">
                    {props?.finished ? moment(props?.finished).format('DD/MM/YYYY HH:mm:ss') : " "}
                  </span>{" "}
                </li>
              ) : (
                <li className="StepProgress-item is-last-item">
                  <span className="primary-text-progress">
                    {" "}
                    {t("Finished")}
                  </span>
                  <span className="second-text-progress"></span>{" "}
                </li>
              )}
            </ul>
          </div>
          <hr class="hr-timeline" />
        </Collapse>
      </Col>
    </>
  );
};
export default withTranslation()(React.memo(VerticalTimeline));

